//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import i18n from "@/utils/i18n";
export default {
  name: "grid-col-span-editor",
  mixins: [i18n],
  props: {
    designer: Object,
    selectedWidget: Object,
    optionModel: Object
  },
  computed: {
    formConfig: function formConfig() {
      return this.designer.formConfig;
    }
  }
};